import axios from "axios";
import { resolveShopApiUrl } from "./shopApi";
import { getFirebaseIDTokenForShop } from "../firebase/firebase";

/**
 * Bestellingen → Testdata: empty one delivery date in a shop's dev project, through that shop's own
 * api. The rules let no client delete orders; the api does it, and only with dev-tools.enabled (the
 * loc profile), on a project whose id ends in -dev, for a cmsAdmin (api DevOrderService).
 *
 * @param {"VCE"|"HVO"} shopSource
 * @param {string} deliveryDate DD-MM-YYYY
 * @returns {Promise<{projectId: string, deliveryDate: string, deleted: number, documentIds: string[]}>}
 */
export const deleteDevOrders = async (shopSource, deliveryDate) => {
  const idToken = await getFirebaseIDTokenForShop(shopSource);
  try {
    const response = await axios.delete(`${resolveShopApiUrl(shopSource)}/api/dev/orders`, {
      params: { deliveryDate },
      headers: { Authorization: `${idToken}` },
    });
    return response.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      throw new Error(
        `${shopSource}: de api kent dit niet. Draait hij met de nieuwste code en met dev-tools.enabled (alleen het loc-profiel)?`,
      );
    }
    throw new Error(`${shopSource}: ${err?.response?.data?.message || err?.message || "verwijderen mislukt"}`);
  }
};
